import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import dataURItoBlob from '../../../Utils/dataUriToBlob';
import { imageUpload } from '../../../Services/APIs/scan';
import InvalidImagePopup from '../InvalidImagePopup';
import ErrorPopup from '../ErrorPopup';
import { logData } from '../../../Services/APIs/scan';

const Preview = ({ imageDataUri, onRetake, goBack }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showInvalidImagePopup, setShowInvalidImagePopup] = useState(false);

  const uid = JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi;
  const company = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket;

  useEffect(() => {
    logData({ uid, company, message: "previewing the image" })

  }, [])

  const handleRetake = () => {
    window.history.back();
  };

  const submit = async () => {
    setLoading(true);
    setShowErrorPopup(false);

    try {
      const blob = dataURItoBlob(imageDataUri); // Convert base64 to Blob
      const file = new File([blob], "report_image.jpeg", {
        type: "image/jpeg",
      });
      const formData = new FormData();
      formData.append("report_image", file);

      const folderName = uid;

      const res = await imageUpload({ formData, folderName });
      localStorage.setItem("imageName", res.data.data.imageName);
      localStorage.setItem("isVyesScanCompleted", true)
      navigate("/unilever/result", { replace: true });
        } catch (err) {
      if (err.response && err.response.status === 406) {
        setShowInvalidImagePopup(true);
      } else {
        setShowErrorPopup(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleTryAgain = () => {
    setShowErrorPopup(false);
    submit();
  };

  const handleClose = () => {
    setShowErrorPopup(false);
  };

  const handleInvalidImageRetake = () => {
    setShowInvalidImagePopup(false);
    goBack();
   };

  const handleInvalidImageClose = () => {
    setShowInvalidImagePopup(false);
  };

  if (!imageDataUri) {
    return <div className="text-white">No image to preview.</div>; // Handle case where no image is passed
  }

  return (
    <div className="relative w-full h-full bg-black flex flex-col items-center justify-center">
      <style>
        {`
          @keyframes full-wipe {
            0% {
              transform: translateY(110vh) rotate(180deg);
            }
            50% {
              transform: translateY(-10vh) rotate(180deg);
            }
            50.01% {
              transform: translateY(-10vh) rotate(0deg);
            }
            100% {
              transform: translateY(110vh) rotate(0deg);
            }
          }
          .animate-full-wipe {
            animation: full-wipe 3s linear infinite;
          }
        `}
      </style>
      <div className="absolute top-4 left-4 z-10">
        <button onClick={handleRetake} className="text-white">
          <ArrowLeft size={24} />
        </button>
      </div>

      <div className="relative w-full flex justify-center items-center" style={{ height: '80%' }}>
        <img src={imageDataUri} alt="Captured" className="max-h-full max-w-full object-contain" />
      </div>

      {loading && (
        <div className="absolute inset-0 bg-black/30 flex flex-col items-center justify-end z-20 pb-20">
          <div className="absolute inset-0 overflow-hidden">
              <div 
                className="absolute w-full h-1/6 bg-gradient-to-t from-white/70 via-white/40 to-transparent animate-full-wipe"
              ></div>
          </div>
          <p className="text-white text-lg md:text-2xl font-semibold">Loading AI Technology...</p>
        </div>
      )}

      {!loading && (
        <div className="absolute bottom-10 w-full px-4">
          <div className="flex flex-row justify-center md:justify-around space-x-2 w-full">
            <button
              onClick={onRetake}
              className="w-1/2 bg-white text-[#D50026] py-2 rounded-full text-lg font-semibold md:w-1/3 md:text-xl    "
            >
              Retake
            </button>
            <button
              onClick={submit}
              className="w-1/2 bg-[#D50026] text-white py-2 rounded-full text-lg font-semibold md:w-1/3 md:text-xl"
            >
              Submit
            </button>
          </div>
        </div>
      )}

      {showErrorPopup && (
        <ErrorPopup onTryAgain={handleTryAgain} onClose={handleClose} />
      )}
      {showInvalidImagePopup && (
        <InvalidImagePopup onRetake={onRetake} onClose={handleInvalidImageClose} />
      )}
    </div>
  );
};

export default Preview;
